import { Route } from "vue-router";
import store from "@/store";
import Pharmacists from "@/views/pharmacists/Index.vue";
import PharmacistAdd from "@/views/pharmacists/Add.vue";

export default [
  {
    path: "account-management",
    name: "pharmacists",
    component: Pharmacists,
    meta: {
      title: "Accountbeheer"
    },
    beforeEnter: (to: Route, from: Route, next: Function) => {
      const isManager = store.getters["auth/isManager"];
      if (isManager) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "account-management/add",
    name: "pharmacistsAdd",
    component: PharmacistAdd,
    meta: {
      title: "Gebruiker toevoegen"
    },
    beforeEnter: (to: Route, from: Route, next: Function) => {
      const isManager = store.getters["auth/isManager"];
      if (isManager) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  }
];
